export default "__VITE_ASSET__DFdDFocG__"